import { RouterModule, Routes } from "@angular/router";
import { PojedinacnaEvidencijaPdv } from "./pojedinacna-evidencija-pdv/pojedinacna-evidencija-pdv";
import { PojedinacnaEvidencijaPdvView } from "./pojedinacna-evidencija-pdv/pojedinacna-evidencija-pdv-view";
import { CanActivateFalseGuard, CanDeactivateGuard, ConditionType, FormType, RefreshType, RequestType, TableRowColorType } from "yt-ng-framework";
import { PojedinacnaEvidencijaPdvTabsComponent } from "./pojedinacna-evidencija-pdv/pojedinacna-evidencija-pdv-tabs.component";
import { NgModule } from "@angular/core";
import { LookupsRoutes } from "../lookups/routes";
import { EpdvComponent } from "./epdv.component";
import { AppComponent } from "../app.component";
import { PravacDokumenta } from "./sifarnici/pravac-dokumenta";
import { TipDokumentaSef } from "./sifarnici/tip-dokumenta-sef";
import { PoreskiPeriod } from "./sifarnici/poreski-period";
import { Period } from "./sifarnici/period";

let childrenRoutes: Routes = [ 
    {
        path: 'pojedinacnaevidencijapdv',
        component: PojedinacnaEvidencijaPdvTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                label: 'TABLE.POJEDINACNAPDVEVIDENCIJA.PLURAL',
                modelName: 'pojedinacnaevidencijapdv',
                getName: 'GetFiltered',
                getParameters: [],
                modelClass: PojedinacnaEvidencijaPdv,
                shortModelClass: PojedinacnaEvidencijaPdvView,
                parentProperty:'',
                tableColumns: [
                    { name: 'BrojPojedinacneEvidencijePdv', label: 'POJEDINACNAEVIDENCIJAPDV.BROJPOJEDINACNEEVIDENCIJE.SINGULAR',visible: true, canHide: true},
                    { name: 'KomitentNaziv', label: 'POJEDINACNAEVIDENCIJAPDV.KOMITENT.SINGULAR',visible: true, canHide: true},
                    { name: 'Period', label: 'POJEDINACNAEVIDENCIJAPDV.PERIOD.SINGULAR',visible: true, canHide: true},
                    { name: 'BrojDokumenta', label: 'POJEDINACNAEVIDENCIJAPDV.BROJDOKUMENTA.SINGULAR',visible: true, canHide: true},
                    { name: 'TipDokumenta', label: 'POJEDINACNAEVIDENCIJAPDV.TIPDOKUMENTA.SINGULAR',visible: true, canHide: true},
                    { name: 'UkupanIznosNaknade', label: 'POJEDINACNAEVIDENCIJAPDV.UKUPANIZNOSNAKNADE.SINGULAR',visible: true, canHide: true, type: 'number', aligment: 'right',format: '1.2-2'},
                    { name: 'ObracunatiPdv', label: 'POJEDINACNAEVIDENCIJAPDV.OBRACUNATIPDV.SINGULAR',visible: true, canHide: true, type: 'number', aligment: 'right',format: '1.2-2'},
                    {
                        name: 'StatusColor'
                        , label: 'POJEDINACNAEVIDENCIJAPDV.STATUSGENERICNAME.SINGULAR'
                        , type: "color-box"
                        , visible: true
                        , candHide: false
                        , width: '15%'
                        , aligment: 'center' 
                        , tooltipName: 'StatusTooltip'
                    }
                    ,{ name: 'StatusGenericName', label: '', visible: false, width: '0%'}


                ],
                tableRowColors: [
                    {
                        ColumnName: 'StatusGenericName',
                        Condition: ConditionType.Equals,
                        Value: '30',
                        Color: '#777',
                        Type: TableRowColorType.Foreground
                    },
                    {
                        ColumnName: 'StatusGenericName',
                        Condition: ConditionType.Equals,
                        Value: 'cancelled',
                        Color: '#777',
                        Type: TableRowColorType.Foreground
                    }
                ],
                tableContextMenuItems:[
                    { Name: 'Item 1', Action: 'OsveziStatus', Label: 'POJEDINACNAEVIDENCIJAPDV.OSVEZISTATUS.ACTION' }           
                    ,{ Name: 'Item 2', Action: 'PonistiEvidenciju', Label: 'POJEDINACNAEVIDENCIJAPDV.PONISTIEVIDENCIJU.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityPonisti }

                ],
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                requestType: RequestType.POST,
                //defaultListFilterComponent: FilterWithKomitentComponent
                defaultPropertyName: 'BrojDokumenta'
            },
            mainTitle: 'pojedinacnaevidencijapdv',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'POJEDINACNAEVIDENCIJAPDV.SINGULAR',
            
            
        }

    },

    {
        path: 'pravacdokumenta',
        component: null,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'PojedinacnaEvidencijaPdv',
                getName: 'GetPravacDokumenta',
                getParameters: [],
                modelClass: PravacDokumenta,
                parentProperty:'',
                tableColumns: [
                    { name: 'Naziv', label: 'POJEDINACNAEVIDENCIJAPDV.NAZIV.SINGULAR',visible: true, canHide: true},
                ],
                // sortBy: 'ID',
                // sortReverse: true,
                // enableEdit: false,
                // enableDelete: true,
                // enablePrint: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                requestType: RequestType.POST,
                //defaultListFilterComponent: FilterWithKomitentComponent
            },
            mainTitle: 'pojedinacnaevidencijapdv',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'POJEDINACNAEVIDENCIJAPDV.SINGULAR'
        }

    },

    {
        path: 'tipdokumentasef',
        component: null,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'PojedinacnaEvidencijaPdv',
                getName: 'GetTipDokumentaSef',
                getParameters: [],
                modelClass: TipDokumentaSef,
                parentProperty:'',
                tableColumns: [
                    //{ name: 'Naziv', label: 'POJEDINACNAEVIDENCIJAPDV.NAZIV.SINGULAR',visible: true, canHide: true},
                    { name: 'Naziv', label: 'POJEDINACNAEVIDENCIJAPDV.TIPDOKUMENTA.SINGULAR', visible: true, candHide: true },
                ],
                // sortBy: 'ID',
                // sortReverse: true,
                // enableEdit: false,
                // enableDelete: true,
                // enablePrint: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                requestType: RequestType.POST,
                //defaultListFilterComponent: FilterWithKomitentComponent
            },
            mainTitle: 'pojedinacnaevidencijapdv',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'POJEDINACNAEVIDENCIJAPDV.SINGULAR'
        }

    },

    {
        path: 'poreskiperiod',
        component: null,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'PojedinacnaEvidencijaPdv',
                getName: 'GetPoreskiPeriod',
                getParameters: [],
                modelClass: PoreskiPeriod,
                parentProperty:'',
                tableColumns: [
                    { name: 'Naziv', label: 'POJEDINACNAEVIDENCIJAPDV.PORESKIPERIOD.SINGULAR',visible: true, canHide: true},
                ],
                // sortBy: 'ID',
                // sortReverse: true,
                // enableEdit: false,
                // enableDelete: true,
                // enablePrint: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                requestType: RequestType.POST,
                //defaultListFilterComponent: FilterWithKomitentComponent
            },
            mainTitle: 'pojedinacnaevidencijapdv',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'POJEDINACNAEVIDENCIJAPDV.SINGULAR'
        }

    },

    {
        path: 'period',
        component: null,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'PojedinacnaEvidencijaPdv',
                getName: 'GetPeriod',
                getParameters: [],
                modelClass: Period,
                parentProperty:'',
                tableColumns: [
                    { name: 'Naziv', label: 'POJEDINACNAEVIDENCIJAPDV.PERIOD.SINGULAR',visible: true, canHide: true},
                ],
                // sortBy: 'ID',
                // sortReverse: true,
                // enableEdit: false,
                // enableDelete: true,
                // enablePrint: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                requestType: RequestType.POST,
                //defaultListFilterComponent: FilterWithKomitentComponent
            },
            mainTitle: 'pojedinacnaevidencijapdv',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'POJEDINACNAEVIDENCIJAPDV.SINGULAR'
        }

    },
    
    // {
    //     path: 'Universal',
    //     component: EpdvComponent,
    //     canActivate: [ CanActivateFalseGuard ],
    //     data: {
    //         mainList: {
    //             modelName: 'enummodel',
    //             modelClass: EnumModel,
    //             parentProperty: '',
    //             tableColumns: [
    //                 //Labele su rotirane iz razloga što su za ID postavljene srpski nazivi, a u Name engleski naziv, zbog progelda
    //                 { name: 'ID', label: 'ID', visible: false },
    //                 { name: 'Name', label: 'Naziv', visible: true }

    //             ]
    //         },

    //     }
    // }
]

childrenRoutes = childrenRoutes.concat(LookupsRoutes);

const routes: Routes = [
{
    path: '',
    component: EpdvComponent,
    children: childrenRoutes
}
   
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EpdvRoutingModule {}

export function CheckContextMenuAvailabilityPonisti(item: PojedinacnaEvidencijaPdvView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName != "30" && item.StatusGenericName != "cancelled" );
}